import { Button, Card, message, Popconfirm, Space } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import AddSubject from "./AddSubject";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

function SubjectsTable() {
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);

  const columns = [
    {
      title: "Subject Name",
      dataIndex: "subject_name",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title="Delete Subject"
                description={`Are you sure to delete ${record.subject_name}?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/subject?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteResponse, deleteRequest] = useApi();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      message.success("Subject Deleted successfully.");
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  const handleAddSubject = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditSubject = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };
  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/admin/subject/${record.id}`);
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/subject?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card title="Subjects"
      extra={<Button type="default" onClick={handleAddSubject}>
        Add Subject
      </Button>}>

      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visible && (
        <AddSubject visible={visible} close={handleAddSubject} />
      )}
      {visibleEdit && (
        <AddSubject
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditSubject}

        />
      )}
    </Card>
  );
}

export default SubjectsTable;
